// Static content for O'javana redesign
export const SOLUTIONS = [
  {
    slug: "pos",
    name: "Point of Sale",
    short: "POS",
    color: "#E11D48",
    tagline: "Sell faster. Close cleaner.",
    description:
      "A blazing-fast cloud POS for restaurants and retail with offline mode, multi-station sync, Kitchen Display System (KDS), Customer Display System (CDS), call-center order entry, UberEats integration and built-in payments.",
    bullets: [
      "Sub-second order entry",
      "Offline-first, never miss a sale",
      "Multi-station + multi-location",
      "Kitchen Display System (KDS)",
      "Customer Display System (CDS)",
      "Call-center order entry",
      "UberEats integration",
      "Built-in payments & tipping",
    ],
  },
  {
    slug: "kiosk",
    name: "Self-Order Kiosk",
    short: "KIOSK",
    color: "#16A34A",
    tagline: "Cut queues. Lift average check 22%.",
    description:
      "Floor-standing and counter-top 23.8\" kiosks that take orders, accept TWINT + cards and route tickets straight to the kitchen.",
    bullets: [
      "23.8\" hardware, counter-top or floor-standing",
      "TWINT, Apple Pay, Google Pay, EMV",
      "Direct-to-kitchen ticket routing",
      "Free with eligible merchant programme",
    ],
    featured: true,
  },
  {
    slug: "waiter-app",
    name: "Waiter App",
    short: "Waiter",
    color: "#7C3AED",
    tagline: "Tableside that actually works.",
    description:
      "Take orders, fire courses and split bills from any handheld — even when the Wi-Fi drops.",
    bullets: ["iOS & Android", "Course firing", "Split & merge checks", "Tip-pool ready"],
  },
  {
    slug: "qr-order-pay",
    name: "QR Order & Pay",
    short: "QR",
    color: "#EA580C",
    tagline: "Scan. Order. Walk away.",
    description:
      "Branded QR menus that turn every table into a self-service revenue channel.",
    bullets: ["Branded menus", "No app download", "Auto-tipping", "Loyalty-ready"],
  },
  {
    slug: "online-shop",
    name: "Online Shop",
    short: "Shop",
    color: "#0284C7",
    tagline: "Your storefront. Your margins.",
    description:
      "Commission-free online ordering with native delivery, pickup and Swisspayout checkout.",
    bullets: ["Zero commission", "Swisspayout checkout", "Native delivery zones", "SEO-ready"],
  },
  {
    slug: "payment-terminals",
    name: "Payment Terminals",
    short: "Pay",
    color: "#51dd7f",
    tagline: "One device. Every payment.",
    description:
      "EMV, contactless, TWINT, Apple Pay and Google Pay — fully integrated with the POS via Swisspayout, no double entry. Choose tethered (S1F2) or untethered with built-in SIM (AMS1).",
    bullets: ["S1F2 tethered terminal", "AMS1 with integrated SIM", "TWINT supported", "0.90% special rate with our terminals"],
  },
  {
    slug: "gift-cards-loyalty",
    name: "Gift Cards & Loyalty",
    short: "Loyalty",
    color: "#F59E0B",
    tagline: "Turn one visit into ten.",
    description:
      "Memberships, fidelity points, one-click physical and digital gift cards — all backed by the same POS that took the sale.",
    bullets: [
      "Memberships & tiered fidelity program",
      "Points, stamps & rewards engine",
      "One-click gift card sales at any station",
      "Customized branded gift cards",
      "Digital gift cards via email & SMS",
      "Auto-redemption at POS, kiosk and online",
    ],
  },
  {
    slug: "inventory",
    name: "Inventory Management",
    short: "Inventory",
    color: "#0EA5E9",
    hidden: true,
    tagline: "Know your shelf. Run your floor.",
    description:
      "Live SKU-level inventory, recipe and cost control, supplier orders and waste tracking — wired into every channel.",
    bullets: [
      "SKU-level real-time stock",
      "Recipe & cost-of-goods control",
      "Supplier orders & receiving",
      "Waste & shrinkage tracking",
      "Multi-location stock transfers",
      "Low-stock alerts & auto-reorder",
    ],
  },
];

export const TESTIMONIALS = [];

export const CASE_STUDIES = [];

export const BLOG_POSTS = [];

export const LOGOS = [];

// Hardware catalog — prices in CHF (ordered as displayed in Configurator)
export const HARDWARE = [
  { sku: "OJ-POS-15", name: "POS Terminal 15\"", price: 490, color: "#E11D48", default_qty: 1 },
  { sku: "OJ-PAY-S1F2", name: "Payment Terminal S1F2 (with printer)", price: 525, color: "#51dd7f", default_qty: 0 },
  { sku: "OJ-PAY-AMS1", name: "Payment Terminal AMS1 (without printer)", price: 275, color: "#51dd7f", default_qty: 0 },
  { sku: "OJ-HANDHELD", name: "Waiter Tablet", price: 189, color: "#7C3AED", default_qty: 0 },
  { sku: "OJ-RCPT-80", name: "Receipt Printer 80mm", price: 180, color: "#0A0A0A", default_qty: 0 },
  { sku: "OJ-CASH", name: "Cash Drawer", price: 120, color: "#0A0A0A", default_qty: 0 },
  { sku: "OJ-BALANCE", name: "Balance Machine", price: 320, color: "#0A0A0A", default_qty: 0 },
  { sku: "OJ-KIOSK-238", name: "Self-Order Kiosk 23.8\"", price: 1980, color: "#16A34A", default_qty: 0 },
  { sku: "OJ-CDS", name: "Customer Display System (CDS) 10\"", price: 220, color: "#0EA5E9", default_qty: 0 },
  { sku: "OJ-KDS-156", name: "Kitchen Display System (KDS) 15.6\"", price: 480, color: "#0284C7", default_qty: 0 },
];

export const SOFTWARE_PRICE_PER_STATION = 69; // CHF / mo / station (Starter base; −CHF 39 with O'javana terminal)

export const SALES_TIERS = [
  { id: "t0", label: "Under CHF 5,000 / mo", min: 0, discount: 0 },
  { id: "t1", label: "CHF 5,000 – 10,000 / mo", min: 5000, discount: 0.30 },
  { id: "t2", label: "CHF 10,000 – 15,000 / mo", min: 10000, discount: 0.40 },
  { id: "t3", label: "CHF 15,000 – 20,000 / mo", min: 15000, discount: 0.50 },
  { id: "t4", label: "CHF 20,000+ / mo", min: 20000, discount: 1.00 },
];

// Global presence — for world map markers
export const GLOBAL_LOCATIONS = [
  { name: "Switzerland", lat: 46.8, lng: 8.2, region: "Europe", role: "HQ" },
  { name: "Germany", lat: 51.1, lng: 10.5, region: "Europe" },
  { name: "France", lat: 46.6, lng: 2.4, region: "Europe" },
  { name: "Italy", lat: 41.9, lng: 12.6, region: "Europe" },
  { name: "Spain", lat: 40.4, lng: -3.7, region: "Europe" },
  { name: "United Kingdom", lat: 54.0, lng: -2.0, region: "Europe" },
  { name: "Austria", lat: 47.5, lng: 14.5, region: "Europe" },
  { name: "United Arab Emirates · Dubai", lat: 25.2, lng: 55.3, region: "MENA" },
  { name: "Saudi Arabia", lat: 24.7, lng: 46.7, region: "MENA" },
  { name: "United States", lat: 38.9, lng: -77.0, region: "North America" },
  { name: "Canada", lat: 45.4, lng: -75.7, region: "North America" },
];

// Payment methods accepted via Swisspayout integration
export const PAYMENT_METHODS = [
  { id: "twint", name: "TWINT", color: "#51dd7f", note: "Switzerland" },
  { id: "visa", name: "Visa", color: "#1A1F71" },
  { id: "mastercard", name: "Mastercard", color: "#EB001B" },
  { id: "amex", name: "American Express", color: "#2E77BB" },
  { id: "applepay", name: "Apple Pay", color: "#000000" },
  { id: "googlepay", name: "Google Pay", color: "#4285F4" },
  { id: "maestro", name: "Maestro", color: "#0099DF" },
  { id: "jcb", name: "JCB", color: "#0E4C96" },
  { id: "unionpay", name: "UnionPay", color: "#E21836" },
  { id: "diners", name: "Diners Club", color: "#0079BE" },
  { id: "discover", name: "Discover", color: "#FF6000" },
  { id: "girocard", name: "girocard", color: "#003DA5" },
];

// Industries served — surfaced in the header dropdown and /industries page
export const INDUSTRIES = [
  {
    slug: "quick-service",
    name: "Quick Service (QSR)",
    color: "#E11D48",
    blurb: "Fast counter service, kiosks and queue-busting payment.",
    points: ["Self-Order Kiosk", "Direct-to-kitchen tickets", "Loyalty + gift cards", "Drive-thru handheld"],
  },
  {
    slug: "delivery-service",
    name: "Delivery Service",
    color: "#EA580C",
    blurb: "Native delivery + UberEats, dispatched from one POS.",
    points: ["UberEats integration", "Online Shop & QR ordering", "Driver dispatch", "Address-zone pricing"],
  },
  {
    slug: "restaurants",
    name: "Restaurants & Cafés",
    color: "#7C3AED",
    blurb: "Tableside ordering, course firing, tip-pool ready.",
    points: ["Waiter App", "Course firing", "Kitchen Display System", "Customer Display System"],
  },
  {
    slug: "grocery-stores",
    name: "Grocery & Convenience",
    color: "#0EA5E9",
    blurb: "SKU-level inventory, scales and barcode workflows.",
    points: ["Inventory management", "Barcode & weighing scale", "Promo + multi-buy rules", "Loyalty memberships"],
  },
  {
    slug: "food-truck",
    name: "Food Truck",
    color: "#16A34A",
    blurb: "Wireless terminals with SIM, offline POS, end-of-shift reports.",
    points: ["Offline-first POS", "AMS1 terminal with integrated SIM", "Crew accounts", "End-of-shift reports"],
  },
  {
    slug: "franchise",
    name: "Franchise & Multi-brand",
    color: "#80CBC7",
    blurb: "Multi-brand, multi-region rollouts with central control.",
    points: ["Multi-location dashboard", "Brand-locked menus", "Royalty reporting", "Central pricing & promos"],
  },
];

// Lightspeed comparison (used on /compare/lightspeed page and CTA card)
export const COMPARE_LIGHTSPEED = [
  { dim: "Monthly price (Starter)", oj: "CHF 39 with our terminal", ls: "CHF 100+ before add-ons", win: true },
  { dim: "Hardware bundle", oj: "Free for eligible merchants", ls: "Paid, often 2–3k CHF", win: true },
  { dim: "Card processing rate", oj: "0.90% with O'javana terminals", ls: "1.5–2.0% typical", win: true },
  { dim: "Installation time", oj: "Within 48 hours", ls: "1–4 weeks", win: true },
  { dim: "Support response", oj: "Same hour / same day", ls: "Ticket queues, callbacks", win: true },
  { dim: "Where it's built", oj: "Born in Neuchâtel · Swiss-made", ls: "Global, no local presence", win: true },
  { dim: "Product focus", oj: "Compact, restaurant + retail", ls: "Many SKUs, lots of upsell", win: true },
  { dim: "TWINT", oj: "Native", ls: "Via partner add-on", win: true },
];
